/* 请求封装 */
import axios from 'axios'
import {Message} from 'element-ui'

// http request 拦截器
//请求拦截
axios.interceptors.request.use(
  config => {// 在发送请求之前做些什么
    if (store.state.token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = `token ${store.state.token}`;
    }
    return config;
  },
  err => {// 对请求错误做些什么
    return Promise.reject(err);
  }
);

// http response 拦截器
//响应拦截 后端返回前端
axios.interceptors.response.use(
  response => { // 对响应数据做点什么
    return response;
  },//响应可以，正常返回数据
  error => {// 对响应错误做些什么
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          store.commit(types.LOGOUT);
          localStorage.removeItem('token') // 清除本地..
          router.replace({
            path: '/',
            // query: {redirect: router.currentRoute.fullPath}
            //携带路由从什么地方失效的
          })
      }
    }
    return Promise.reject(error.response.data)  // 返回接口返回的错误信息
  }
);

let http = axios.create({
  crossDomain: true,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

function apiAxios (method, url, params, headers, blenderApiUrl, response, responseType) {
  http({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' || method === 'DELETE' || method === 'PATCH' ? params : null,
    params: method === 'GET' ? params : null,
    baseURL: blenderApiUrl === '' ? process.env.BASE_URL : blenderApiUrl,
    headers: headers,
    responseType: responseType ? 'blob' : ''
  }).then(function (res) {
    response(res)
  }).catch(function (err) {
    console.log(err)
    if (err.response.status === 401) {
      Message({
        showClose: true,
        duration: 0,
        message: '' + JSON.stringify(err.response.statusText).toString() + ':' + JSON.stringify(err.response.data.detail).toString() + '',
        type: 'error'
      })
      top.postMessage('logout', '*')
      window.location = '/'
    } else {
      let message
      if(err.response.data.detail === 'LOGIN_BAD_CREDENTIALS') {
        message = '用户名或密码错误，请重新输入'
      } else if(err.response.data.detail === 'REGISTER_USER_ALREADY_EXISTS') {
        message = '邮箱已存在，请重新输入'
      } else {
        message = JSON.stringify(err.response.data).toString()
      }
      Message({
        showClose: true,
        duration: 0,
        message: '' + message + '',
        type: 'error'
      })
    }
    response(err)
  })
}
function apiFileAxios (method, url, params, headers, blenderApiUrl, response) {
  let http = axios.create({
    crossDomain: true,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
  http({
    method: method,
    url: url,
    responseType: 'blob',
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: blenderApiUrl,
    headers: headers
  }).then(function (res) {
    response(res)
  }).catch(function (err) {
    if (err.response.status === 401) {
      Message({
        showClose: true,
        duration: 0,
        message: '' + JSON.stringify(err.response.statusText).toString() + ':' + JSON.stringify(err.response.data.detail).toString() + '',
        type: 'error'
      })
      top.postMessage('logout', '*')
    } else {
      Message.error('' + JSON.stringify(err.response.data).toString() + '')
    }
    response(err)
  })
}
function apiZpiFileAxios (method, url, params, headers, blenderApiUrl, response) {
  let httpZip = axios.create({
    crossDomain: true,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/zip'
    }
  })
  httpZip({
    method: method,
    url: url,
    responseType: 'blob',
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: blenderApiUrl,
    headers: headers
  }).then(function (res) {
    response(res)
  }).catch(function (err) {
    if (err.response.status === 401) {
      Message({
        showClose: true,
        duration: 0,
        message: '' + JSON.stringify(err.response.statusText).toString() + ':' + JSON.stringify(err.response.data.detail).toString() + '',
        type: 'error'
      })
      top.postMessage('logout', '*')
    } else {
      Message.error('' + JSON.stringify(err.response.data).toString() + '')
    }
    response(err)
  })
}

export default {
  get: function (url, params, headers, blenderApiUrl, response) {
    return apiAxios('GET', url, params, headers, blenderApiUrl, response)
  },
  post: function (url, params, headers, blenderApiUrl, response, responseType) {
    return apiAxios('POST', url, params, headers, blenderApiUrl, response, responseType)
  },
  patch: function (url, params, headers, blenderApiUrl, response, responseType) {
    return apiAxios('PATCH', url, params, headers, blenderApiUrl, response, responseType)
  },
  put: function (url, params, headers, blenderApiUrl, response) {
    return apiAxios('PUT', url, params, headers, blenderApiUrl, response)
  },
  delete: function (url, params, headers, blenderApiUrl, response) {
    return apiAxios('DELETE', url, params, headers, blenderApiUrl, response)
  },
  getFile: function (url, params, headers, blenderApiUrl, response) {
    return apiFileAxios('GET', url, params, headers, blenderApiUrl, response)
  },
  getZipFile: function (url, params, headers, blenderApiUrl, response) {
    return apiZpiFileAxios('POST', url, params, headers, blenderApiUrl, response)
  },
  downFileProgress: function (url, params, headers, blenderApiUrl, callback, uniSign) {
    return axios({
      url: url,
      params: params,
      method: 'get',
      responseType: 'blob',
      baseURL: blenderApiUrl,
      headers: headers,
      onDownloadProgress (progress) {
        callback(progress, uniSign)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/config.js